import Stack from '@mui/material/Stack';
import { DetailsSection } from '../DetailsSection';
import { AttachmentsSection } from '../AttachmentsSection';
import { OverviewAccordion } from './OverviewAccordion';
import { abyssColors } from '@/theme/colors';

export const ComponentsOverview = () => {
  return (
    <Stack
      spacing={2}
      padding="2.4rem"
      sx={{
        height: '80vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '1.4rem',
        },
        '&::-webkit-scrollbar-track': {
          background: abyssColors.primary[100],
        },
        '&::-webkit-scrollbar-thumb': {
          background: abyssColors.primary[200],
          borderRadius: '1rem',
          height: '0.6rem',
          border: `0.4rem solid ${abyssColors.primary[100]}`,
          cursor: 'grabbing',
        },
      }}
    >
      <>
        <OverviewAccordion title="Details" details={<DetailsSection />} defaultExpanded={true} />
        <OverviewAccordion
          title="Attachments"
          details={<AttachmentsSection />}
          defaultExpanded={false}
        />
      </>
    </Stack>
  );
};
